exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employees-view-contents {\n  margin: 1em 2em; }\n\n.employees-list {\n  width: 1000px;\n  margin: 1em auto;\n  background: white;\n  clear: both; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/employees/views/employeesView/employeesView.component.scss
// module id = ./src/app/modules/employees/views/employeesView/employeesView.component.scss
// module chunks = main